module.exports = __webpack_public_path__ + "img/SDLRSAT.609d8d8b.svg";